export default __webpack_public_path__ + "Src/Client/Account/signedOut.html";